import { styled } from "@mui/material/styles"
import { Box, Stack, Card, Chip } from "@mui/material"

export const FilterContainer = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
}))

export const FilterWrapperBox = styled(Stack)(({ theme }) => ({
  flex: 1,
  flexWrap: "wrap",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    alignItems: "stretch",
  },
}))

export const WarningMessageContainer = styled(Card)(({ theme }) => ({
  display: "flex",
  flex: 1,
  position: "absolute",
  width: "100%",
  height: "100%",
}))

export const WarningMessageWrapper = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  flex: 1,
}))

export const WarningMessage = styled(Box)(({ theme }) => ({
  color: "#a9b7c0",
  textAlign: "center",
}))

export const ChipTag = styled(Chip)(({ theme, directionlabel }) => ({
  paddingTop: "8px",
  paddingBottom: "8px",
  borderRadius: "8px",
  paddingLeft: "4px",
  paddingRight: "4px",
  borderColor: "rgba(0,0,0,.12)",
  ".MuiChip-deleteIcon": {
    color: "rgba(0, 0, 0, 0.65)",
    fontWeight: "normal",
  },
  color: "rgba(0, 0, 0, 1)",
  backgroundColor: "#fafafa",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "16px",
  ".MuiChip-label": {
    direction: directionlabel,
    textAlign: "left",
    maxWidth: 350,
  },
}))
